import templateUrl from "emun.order/order-print.htm";
import orderConfig from "emun.order/order.config";
import basicController from "servicestack/basic.controller.properties";
import open from "webmodals/open";
import cacheBusterGuid from "webutils/services/cache-buster-guid";

export default (options) =>
  open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    title: "Print Order",
    bindToController: true,
    controllerAs: "$ctrl",
    controller() {
      const $ctrl = this;

      $ctrl.title = "Print Order";
      $ctrl.lineStatus = "All";
      $ctrl.request = Object.assign(
        {
          IncludeImages: false,
          IncludeBarcodes: false,
          OrderBy: "strProductID",
        },
        options.request
      );
      $ctrl.orderConfig = orderConfig;
      basicController($ctrl);
      $ctrl.gotoUrl = (orderBy, includeImages, includeBarcodes, reportName) => {
        var url = $ctrl.$appConfig.resolveServiceUrl(
          "SalesOrderPrint/" + $ctrl.request.id + "?"
        );
        url += "OrderBy=" + orderBy;
        url += "&LineStatus=" + $ctrl.lineStatus || "All";
        url += "&IncludeImages=" + includeImages;
        url += "&IncludeBarcodes=" + includeBarcodes;
        if (reportName) url += "&ReportName=" + reportName;
        url += cacheBusterGuid();
        $ctrl.$notify.info(
          "Thank you for your patience as your report is processed",
          {
            title: `Generating ${reportName || "Report"} [${
              $ctrl.request.id
            }]...`,
            ttl: 5000,
          }
        );
        window.open(url, $ctrl.$session.localMode ? "_self" : "_blank");
      };
      $ctrl.getUrl = () =>
        $ctrl.$appConfig.resolveServiceUrl(
          `SalesOrderPrint/${$ctrl.request.id}?${Object.keys($ctrl.request)
            .map((key) => key + "=" + $ctrl.request[key])
            .join("&")}`
        );
    },
  }).result;
